<template>
  <div>
    <v-select
      v-model="calculationTypeInternal"
      :items="Object.values(calculationTypeData)"
      item-text="label"
      item-value="key"
      dense
      filled
      hide-details
      class="v-text-field--no-border v-text-field--small v-text-field--light-suffix"
    />
    <currency-input
      v-model="valueInternal"
      :class="{ 'error lighten-2': !valueInternal || valueInternal === 0 }"
      filled
      dense
      hide-details
      :precision="0"
      :suffix="calculationTypeInternal === calculationTypePercentageOfValue || calculationTypeInternal === calculationTypePercentageOfIncome ? '%' : currency"
      class="v-text-field--no-border v-text-field--small v-text-field--light-suffix"
    />
  </div>
</template>

<script>
import CurrencyInput from '@/components/helpers/CurrencyInput'
import YachtType from '@/models/YachtType'

export default {
    name: 'CostControlTableColumn',
    components: {
      CurrencyInput
    },
    props: {
      value: {
        type: Number,
        default: 0
      },
      calculationType: {
        type: String,
        default: YachtType.CALCULATION_TYPE_FIXED
      },
      currency: {
        type: String,
        default: 'EUR'
      }
    },
    computed: {
      calculationTypeInternal: {
        get() {
          return this.calculationType
        },
        set(value) {
          this.$emit('update:calculationType', value)
        }
      },
      valueInternal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    watch: {
    },
    created() {
      this.calculationTypeData = YachtType.CALCULATION_TYPE_DATA

      this.calculationTypeFixed = YachtType.CALCULATION_TYPE_FIXED
      this.calculationTypePerFt = YachtType.CALCULATION_TYPE_PER_FT
      this.calculationTypePercentageOfValue = YachtType.CALCULATION_TYPE_PERCENTAGE_OF_VALUE
      this.calculationTypePercentageOfIncome = YachtType.CALCULATION_TYPE_PERCENTAGE_OF_INCOME
    },
    methods: {
    }
  }
</script>
